import { useEffect } from "react"
import { Grid } from "@material-ui/core"
import { useDispatch, useSelector } from "react-redux"
import { closeModalLandingPaqueteAction, obtenerLandingPaqueteAction, obtenerLandingHabilitadosAction } from "./../../../ducks/landingDuck"
import { offLoadAction, onLoadAnction } from "./../../../ducks/loadDuck"
import HeaderModal from "./../../../global/headerModal"
import ModalBase from "./../../../global/ModalBase"
import { makeStyles } from "@material-ui/core"
import ListaCheck from "./ListaCheck"

export const FPaquetesStyle = makeStyles((theme) => ({
    textField: {
        width: '90%',
        margin: "5px",
        paddingBottom: 0,
        fontWeight: 500
    },
    textFieldMultiLinea: {
        width: '95%',
        margin: "5px",
        paddingBottom: 0,
        fontWeight: 500
    },
    formControl: {
        width: "97%",
        margin: "5px"
    },
    containerSpacing: {
        margin: "10px 5px",
        padding: "10px 10px"
    },
    containerSpacingItem: {
        margin: "10px 10px"
    },
    modalBotonesCenter: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    modalBotones: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    modalBoton: {
        margin: "15px 10px",
        width: "20%"
    },
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        maxWidth: "600px",
        margin: "0 auto",
        padding: theme.spacing(1),
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        border: 'none',
        boxShadow: theme.shadows[10],
        padding: theme.spacing(1, 2, 1),
        minWidth: "90%",
    },
}))

const LandingPaquete = () => {
    const { modal, clavePaquete } = useSelector(store => store.landing)
    const dispatch = useDispatch()
    const classes = FPaquetesStyle()
    useEffect(() => {
        dispatch(onLoadAnction({ message: "" }))
        dispatch(obtenerLandingHabilitadosAction()).then(
            (Response) => {
                dispatch(offLoadAction())
            }
        )
    }, [dispatch])

    useEffect(() => {
        dispatch(onLoadAnction({ message: "" }))
        dispatch(obtenerLandingPaqueteAction({ ClavePaquete: clavePaquete })).then(
            (Response) => {
                dispatch(offLoadAction())
            }
        )
    }, [dispatch, clavePaquete])

    const ToggleModal = () => {
        dispatch(closeModalLandingPaqueteAction())
    }
    return (
        <div>
            <ModalBase
                classes={classes}
                open={modal}
                onClose={ToggleModal}
            >
                <HeaderModal titulo={`Catalogo de landings`} handleClose={ToggleModal} />
                <Grid container className={classes.containerSpacing}>
                    <ListaCheck />
                </Grid>
            </ModalBase>
        </div>
    )
}
export default LandingPaquete
